<template>
  <v-data-table
    :headers="headers"
    :items="turmas"

    :sort-desc="true"

    class="elevation-1"
    :search="search"
  >

    <template v-slot:top>
      <v-toolbar flat color="white">
         <v-progress-circular
                        :size="50"
                        color="green"
                        indeterminate
                         v-if="isLoading"
                      ></v-progress-circular>
        <v-btn
          to="/menu-Minipauta"
          class="mx-2"
          fab
          dark
          color="primary"
        >
          <v-icon dark>arrow_back</v-icon>
        </v-btn>

        <v-divider class="mx-8" inset vertical></v-divider>
        <v-toolbar-title>
          Turma(s) da
          <span v-if="idclasse === 1">10ª classe</span>
          <span v-if="idclasse === 2">11ª classe</span>
          <span v-if="idclasse === 3">12ª classe</span>
          <span v-if="idclasse === 4">13ª classe</span>
        </v-toolbar-title>
        <v-divider class="mx-8" inset vertical></v-divider>
             <span>Selecionado : <strong style="font-size:22px;">{{$store.state.novadescricaoSelecionado}}</strong></span>
        <!--  search  -->
        <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">
          {{ $store.state.textMessage }}
        </div>

        <div class="flex-grow-1"></div>

        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <!-- end  search  -->

        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">

          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }} -</span>
              <span v-if="idclasse === 1">10ª classe</span>
              <span v-if="idclasse === 2">11ª classe</span>
              <span v-if="idclasse === 3">12ª classe</span>
              <span v-if="idclasse === 4">13ª classe</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-form ref="form" v-model="formValid" lazy-validation>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <div
                        v-if="$store.state.hasMessage"
                        :class="$store.state.classMessage"
                      >
                        {{ $store.state.textMessage }}
                      </div>

                      <span
                        v-if="sala && flag_curso && editedItem.periodo.value"
                        ref="myid"
                      >
                        {{
                          flag_curso
                            .trim()
                            .toUpperCase()
                            .substring(0, 3)
                            .concat("-")
                            .concat("SALA " + sala.padStart(2, "0") + "-")
                            .concat(editedItem.periodo.value + "-" + classeTur)
                        }}
                      </span>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-combobox
                        v-model="editedItem.idCurso"

                        item-text="descricao"
                        @change="createdTurmaflag_description"
                        :items="cursos"
                        chips
                        label="Curso"
                      ></v-combobox>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <v-text-field
                        :rules="notaRules"
                        v-model="sala"
                        label="Sala"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <v-combobox
                        v-model="editedItem.periodo"

                        item-value="value"
                        item-text="descricao"
                        :items="periodos"
                        chips
                        label="Periodo"
                      ></v-combobox>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn
                color="blue darken-1"
                v-if="
                  !(formValid && sala && flag_curso && editedItem.periodo.value)
                "
                text
                @click="save"
                >Save</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
        <v-icon  class="mr-2" @click=" disciplinasDaTurma(item) "  style="color:green">list</v-icon>

    </template>
    <template v-slot:no-data>
      no data
    </template>
  </v-data-table>
</template>
<script>
import axios from '../../plugins/axios'
// import jsreport from 'jsreport-browser-client-dist/jsreport'
const ls = require('local-storage')
// const fs = require('fs')
// const request = require('request')
const help = require('../../../Helpers/Helpers')
export default {
  data: () => ({
    option: { 'format': 'A3',
      'orientation': 'landscape',
      paginationOffset: 2,
      'header': {
        'height': '10mm',
        'contents': '<div style="text-align: center;">Author: Marc Bachmann</div>' },
      'footer': {
        'height': '5mm'
      } },
    url: ``,
    text: '',
    flag_curso: '',
    formValid: true,
    alunosTurma: [],
    flag_periodo: '',
    flag_sala: '',
    flag_class: '',
    sala: '',
    search: '',
    quant: 0,
    cursos: [],
    html: ``,
    disciplinas: [],
    notas: [],
    isLoading: false,
    notaRules: [
      // this.value.replace(/[^\d]/, ''),
      v => (v >= 0 && v <= 100) || 'valor da sala invalida',
      v => !!v || 'campo obrigatório.',
      v => !isNaN(v) || 'not number ',

      v => v.length <= 2 || 'valor inválido'
    ],
    periodos: [
      { descricao: 'Manhã', value: 'M' },
      { descricao: 'Tarde', value: 'T' }
    ],
    turmas: [],
    dialog: false,
    headers: [
      {
        text: 'descricao',
        align: 'left',
        sortable: false,
        value: 'turmadescricao'
      },
      { text: 'Periodo', value: 'periodo' },
      { text: 'Curso', value: 'curso' },
      { text: 'Numero de Alunos', value: 'quantalunos' },
      { text: 'Modificado', value: 'data_2' },
      { text: 'Acção', value: 'action', sortable: false }
    ],

    editedIndex: -1,
    editedItem: {
      idCurso: 0,
      idAno_Academico: 0,
      descricao: '',
      autor: '',
      periodo: '',
      idinstituicao: ''
    },
    defaultItem: {
      idCurso: 0,
      idAno_Academico: 0,
      descricao: '',
      autor: '',
      periodo: '',
      idinstituicao: ''
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Nova Turma' : 'Editar Turma'
    },

    idclasse () {
      return this.$store.state.idclasse
    },
    classeTur () {
      return this.$store.state.classeTur
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    // check if classe has been selected otherwise send back to painel to select
    this.initializeCursos()
    this.initializeturmasAll()
  },

  methods: {
    disciplinasDaTurma (dados) {
      let turma = {
        anoLectivo: dados.anoLectivo,
        idCurso: dados.idCurso,
        pkTurma: dados.pkTurma,
        idclasse: dados.idAno_Academico,
        periodo: dados.periodo,
        turma: dados.turmadescricao,
        curso: dados.curso
      }

      ls.set('disciplinasDaTurma', turma)
      if (ls.get('i_id') === 24) {
        this.$router.push('minipauta24')
      } else {
        this.$router.push('minipauta24')
      }
    },
    createdTurmaflag_description () {
      // flag_periodo:'',
      // flag_sala:

      this.flag_curso = this.editedItem.idCurso.descricao

      //  this.flag_sala = this.sala
    },
    async initializeCursos () {
      try {
        //  this.isLoading = true
        this.cursos = await axios.get('/cursoFindAll').then(res => res.data)
      } catch (error) {
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    async initializeturmasAll () {
      try {
        this.isLoading = true
        this.turmas = await axios
          .get('/turmaFindAll-Anolectivo/' + this.$store.state.anolectivoSelecionado + '/' + this.$store.state.idclasse)
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    editItem (item) {
      this.editedIndex = this.turmas.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.turmas.indexOf(item)
      confirm('Are you sure you want to delete this item?') &&
        this.turmas.splice(index, 1)
      this.EliminaTurma(item)
    },
    async EliminaTurma (item) {
      try {
        //  this.isLoading = true
        this.alunosTurma = await axios.get('/turmaFindCountPk/' + item.pkTurma).then(res => res.data)
        if (!this.alunosTurma.length) {
          this.Eliminar(item)
        } else {
          this.text = 'Está turma não pode ser eliminada'
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgError',
            timeout: 2000
          })
        }
      } catch (error) {
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    async Eliminar (item) {
      try {
        this.msg = await axios
          .get('/EliminarTurma/' + item.pkTurma)
          .then(res => res.data)

        this.text = this.msg
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgSucess',
          timeout: 4000
        })
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    ListagemEstudantes (item) {
      this.$store.state.objturma = item
      this.$router.push('ListaAlunos')
    },

    async save () {
      try {
        var params = {
          idCurso: this.editedItem.idCurso.idCurso,
          idAno_Academico: this.idclasse,
          descricao: this.$refs.myid.innerText,
          autor: '',
          periodo: this.editedItem.periodo.descricao
        }
      } catch (error) {

      }

      let turmajaexiste = this.turmas.filter(
        t => t.turmadescricao === this.$refs.myid.innerText
      )

      if (!turmajaexiste.length > 0) {
        try {
          let msg = await axios
            .post('/turmaInsertOne', params)
            .then(res => res.data)
          // this.text = msg[1].insertId
          this.text = msg
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgSucess',
            timeout: 2000
          })

          try {
            if (msg.affectedRows >= 1) {
              this.text = msg.affectedRows + ' gravado(s) com sucesso'
              this.$store.dispatch('textMessage', {
                msg: this.text,
                classMessage: 'msgSucess',
                timeout: 2000
              })
            }
          } catch (error) {}
          try {
            this.text = msg.message.sqlMessage
            this.$store.dispatch('textMessage', {
              msg: this.text,
              classMessage: 'msgError',
              timeout: 8000
            })
          } catch (error) {}
          try {
            this.text = msg.message.sqlMessage
            this.$store.dispatch('textMessage', {
              msg: this.text,
              classMessage: 'msgError',
              timeout: 8000
            })
          } catch (error) {}
        } catch (error) {
          this.isLoading = false

          this.text = error.message
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgError',
            timeout: 8000
          })
        } finally {
        }
        let d = new Date()
        d = new Date(d.getTime() - 3000000)
        // eslint-disable-next-line camelcase
        let date_format_str = d.getFullYear().toString() + '-' + ((d.getMonth() + 1).toString().length === 2 ? (d.getMonth() + 1).toString() : '0' + (d.getMonth() + 1).toString()) + '-' + (d.getDate().toString().length === 2 ? d.getDate().toString() : '0' + d.getDate().toString()) + ' ' + (d.getHours().toString().length === 2 ? d.getHours().toString() : '0' + d.getHours().toString()) + ':' + ((parseInt(d.getMinutes() / 5) * 5).toString().length === 2 ? (parseInt(d.getMinutes() / 5) * 5).toString() : '0' + (parseInt(d.getMinutes() / 5) * 5).toString()) + ':00'
        let v = {
          turmadescricao: this.$refs.myid.innerText,
          periodo: this.editedItem.periodo.descricao,
          curso: this.editedItem.idCurso.descricao,
          data_2: date_format_str
        }

        this.turmas.unshift(v)
        this.close()
      } else {
        this.$store.dispatch('textMessage', {
          msg: 'A turma já existe',
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    }
  }
}
</script>
